import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ShoppingCart, Heart } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { useFavorites } from "@/context/FavoritesContext";
import { brl } from "@/lib/api";

export function ProductCard({ product, index = 0 }) {
  const { add } = useCart();
  const { isFav, toggle } = useFavorites();
  const fav = isFav(product.id);
  const onSale = product.sale_price != null && product.sale_price < product.price;
  const effective = onSale ? product.sale_price : product.price;
  const discountPct = onSale ? Math.round((1 - product.sale_price / product.price) * 100) : 0;

  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{ duration: 0.5, delay: (index % 6) * 0.06 }}
      className="group flex flex-col overflow-hidden rounded-xl border border-borderlight bg-white shadow-sm transition-shadow duration-300 hover:shadow-md"
      data-testid={`product-card-${product.id}`}
    >
      <div className="relative">
        <Link to={product?.id ? `/produto/${product.id}` : "/loja"} className="block">
          <div className="aspect-square overflow-hidden bg-sand-elevated">
            <img src={product.image} alt={product.name}
              className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
          </div>
        </Link>
        <button onClick={() => toggle(product.id)} data-testid={`fav-${product.id}`}
          className="absolute right-3 top-3 flex h-8 w-8 items-center justify-center rounded-full bg-white/90 text-ink shadow-sm transition-colors hover:text-clay">
          <Heart size={16} fill={fav ? "#3E7D4F" : "none"} stroke={fav ? "#3E7D4F" : "currentColor"} />
        </button>
        {onSale ? (
          <span className="absolute left-3 top-3 rounded-full bg-ochre px-2.5 py-1 text-[10px] font-bold uppercase tracking-wide text-forest-deep">
            -{discountPct}%
          </span>
        ) : product.bestseller && (
          <span className="absolute left-3 top-3 rounded-full bg-clay px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wide text-white">
            Mais vendido
          </span>
        )}
      </div>

      <div className="flex flex-1 flex-col p-4">
        <Link to={product?.id ? `/produto/${product.id}` : "/loja"}>
          <h3 className="font-serif text-lg font-medium leading-tight text-forest-deep transition-colors group-hover:text-clay">{product.name}</h3>
        </Link>
        <p className="mt-0.5 font-sans text-xs text-ink/50">{product.tagline}</p>
        <div className="mt-3">
          <div className="flex items-baseline gap-2">
            <p className="font-sans text-xl font-semibold text-forest-deep">{brl(effective)}</p>
            {onSale && <p className="font-sans text-sm text-ink/40 line-through">{brl(product.price)}</p>}
          </div>
          <p className="font-sans text-[11px] text-ink/50">ou 3x de {brl(effective / 3)} sem juros</p>
        </div>
        <button onClick={() => add({ ...product, price: effective })} data-testid={`add-to-cart-${product.id}`}
          className="mt-3 flex items-center justify-center gap-2 rounded-lg bg-forest-deep py-2.5 font-sans text-sm font-medium text-white transition-colors hover:bg-clay">
          <ShoppingCart size={15} /> Adicionar
        </button>
      </div>
    </motion.div>
  );
}
